/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AuthenticatedResponse,
    AuthenticatedResponseFromJSON,
    AuthenticatedResponseToJSON,
} from '../models/AuthenticatedResponse';
import {
    type ChangePasswordInput,
    ChangePasswordInputFromJSON,
    ChangePasswordInputToJSON,
} from '../models/ChangePasswordInput';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type UpdatePasswordInput,
    UpdatePasswordInputFromJSON,
    UpdatePasswordInputToJSON,
} from '../models/UpdatePasswordInput';
import {
    type UserData,
    UserDataFromJSON,
    UserDataToJSON,
} from '../models/UserData';
import {
    type UserProfileInput,
    UserProfileInputFromJSON,
    UserProfileInputToJSON,
} from '../models/UserProfileInput';
import {
    type UserProjects200Response,
    UserProjects200ResponseFromJSON,
    UserProjects200ResponseToJSON,
} from '../models/UserProjects200Response';
import {
    type UserSettings,
    UserSettingsFromJSON,
    UserSettingsToJSON,
} from '../models/UserSettings';

export interface ChangePasswordRequest {
    userId: string;
    changePasswordInput?: ChangePasswordInput;
}

export interface GetUserSettingsRequest {
    userId: string;
}

export interface UpdatePasswordRequest {
    userId: string;
    updatePasswordInput?: UpdatePasswordInput;
}

export interface UpdateProfileRequest {
    userId: string;
    userProfileInput?: UserProfileInput;
}

export interface UpdateUserSettingsRequest {
    userId: string;
    userSettings?: UserSettings;
}

export interface UploadAvatarRequest {
    userId: string;
    avatar?: Blob;
}

export interface UserDetailRequest {
    userId: string;
}

export interface UserProjectsRequest {
    userId: string;
    page?: number;
    pageSize?: UserProjectsPageSizeEnum;
    searchTerm?: string | null;
    sortBy?: UserProjectsSortByEnum;
    sortDirection?: UserProjectsSortDirectionEnum;
}

/**
 * 
 */
export class UserApi extends runtime.BaseAPI {

    /**
     * Creates request options for changePassword without sending the request
     */
    async changePasswordRequestOpts(requestParameters: ChangePasswordRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling changePassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/user/{userId}/change-password`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangePasswordInputToJSON(requestParameters['changePasswordInput']),
        };
    }

    /**
     * Only administrators can specify other `userId` than id of currently authenticated user. Administrators with permission `ModifyUsers` do not have to fill old password.
     */
    async changePasswordRaw(requestParameters: ChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.changePasswordRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Only administrators can specify other `userId` than id of currently authenticated user. Administrators with permission `ModifyUsers` do not have to fill old password.
     */
    async changePassword(requestParameters: ChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.changePasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getUserSettings without sending the request
     */
    async getUserSettingsRequestOpts(requestParameters: GetUserSettingsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUserSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/user/{userId}/settings`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Only administrators can specify other `userId` than id of currently authenticated user.
     */
    async getUserSettingsRaw(requestParameters: GetUserSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSettings>> {
        const requestOptions = await this.getUserSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSettingsFromJSON(jsonValue));
    }

    /**
     * Only administrators can specify other `userId` than id of currently authenticated user.
     */
    async getUserSettings(requestParameters: GetUserSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSettings> {
        const response = await this.getUserSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updatePassword without sending the request
     */
    async updatePasswordRequestOpts(requestParameters: UpdatePasswordRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updatePassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/user/{userId}/update-password`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePasswordInputToJSON(requestParameters['updatePasswordInput']),
        };
    }

    /**
     * Allows to change your password without an old password. Only available when you are forced to update it.
     */
    async updatePasswordRaw(requestParameters: UpdatePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthenticatedResponse>> {
        const requestOptions = await this.updatePasswordRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthenticatedResponseFromJSON(jsonValue));
    }

    /**
     * Allows to change your password without an old password. Only available when you are forced to update it.
     */
    async updatePassword(requestParameters: UpdatePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthenticatedResponse> {
        const response = await this.updatePasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateProfile without sending the request
     */
    async updateProfileRequestOpts(requestParameters: UpdateProfileRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updateProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/user/{userId}/profile`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserProfileInputToJSON(requestParameters['userProfileInput']),
        };
    }

    /**
     * Only administrators can specify other `userId` than id of currently authenticated user.
     */
    async updateProfileRaw(requestParameters: UpdateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserData>> {
        const requestOptions = await this.updateProfileRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserDataFromJSON(jsonValue));
    }

    /**
     * Only administrators can specify other `userId` than id of currently authenticated user.
     */
    async updateProfile(requestParameters: UpdateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserData> {
        const response = await this.updateProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateUserSettings without sending the request
     */
    async updateUserSettingsRequestOpts(requestParameters: UpdateUserSettingsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updateUserSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/user/{userId}/settings`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserSettingsToJSON(requestParameters['userSettings']),
        };
    }

    /**
     * Only administrators can specify other `userId` than id of currently authenticated user.
     */
    async updateUserSettingsRaw(requestParameters: UpdateUserSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserSettings>> {
        const requestOptions = await this.updateUserSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserSettingsFromJSON(jsonValue));
    }

    /**
     * Only administrators can specify other `userId` than id of currently authenticated user.
     */
    async updateUserSettings(requestParameters: UpdateUserSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserSettings> {
        const response = await this.updateUserSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uploadAvatar without sending the request
     */
    async uploadAvatarRequestOpts(requestParameters: UploadAvatarRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling uploadAvatar().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['avatar'] != null) {
            formParams.append('avatar', requestParameters['avatar'] as any);
        }


        let urlPath = `/api/v1/user/{userId}/avatar`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
    }

    /**
     * Only administrators can specify other `userId` than id of currently authenticated user.
     */
    async uploadAvatarRaw(requestParameters: UploadAvatarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserData>> {
        const requestOptions = await this.uploadAvatarRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserDataFromJSON(jsonValue));
    }

    /**
     * Only administrators can specify other `userId` than id of currently authenticated user.
     */
    async uploadAvatar(requestParameters: UploadAvatarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserData> {
        const response = await this.uploadAvatarRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userDetail without sending the request
     */
    async userDetailRequestOpts(requestParameters: UserDetailRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/user/{userId}/detail`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Only administrators can specify other `userId` than id of currently authenticated user.
     */
    async userDetailRaw(requestParameters: UserDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserData>> {
        const requestOptions = await this.userDetailRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserDataFromJSON(jsonValue));
    }

    /**
     * Only administrators can specify other `userId` than id of currently authenticated user.
     */
    async userDetail(requestParameters: UserDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserData> {
        const response = await this.userDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userProjects without sending the request
     */
    async userProjectsRequestOpts(requestParameters: UserProjectsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userProjects().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['searchTerm'] != null) {
            queryParameters['searchTerm'] = requestParameters['searchTerm'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sortDirection'] = requestParameters['sortDirection'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/user/{userId}/projects`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Paginated list of user projects he is allowed to see or manage.
     */
    async userProjectsRaw(requestParameters: UserProjectsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserProjects200Response>> {
        const requestOptions = await this.userProjectsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserProjects200ResponseFromJSON(jsonValue));
    }

    /**
     * Paginated list of user projects he is allowed to see or manage.
     */
    async userProjects(requestParameters: UserProjectsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserProjects200Response> {
        const response = await this.userProjectsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const UserProjectsPageSizeEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type UserProjectsPageSizeEnum = typeof UserProjectsPageSizeEnum[keyof typeof UserProjectsPageSizeEnum];
/**
 * @export
 */
export const UserProjectsSortByEnum = {
    Name: 'name',
    LastInteraction: 'lastInteraction'
} as const;
export type UserProjectsSortByEnum = typeof UserProjectsSortByEnum[keyof typeof UserProjectsSortByEnum];
/**
 * @export
 */
export const UserProjectsSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type UserProjectsSortDirectionEnum = typeof UserProjectsSortDirectionEnum[keyof typeof UserProjectsSortDirectionEnum];
